<h1 mat-dialog-title>Upload Judge Spreadsheet</h1>
<div mat-dialog-content>
    <p>
        Please choose your judge import spreadsheet that you have filled out with all the judges you wish to add.
    </p>
    <div>
        <mat-form-field><input matInput type="text" readonly placeholder="{{file?.name}}" /></mat-form-field>
        <input #fileUpload hidden type="file" (change)="onFileSelected($event.target.files)" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
        <button mat-raised-button [color]="'primary'" type="button" (click)="fileUpload.click()" class="fileButton"><i class="material-icons">attachment</i> Choose File</button>
        <mat-error *ngIf="multipleFiles">Please choose only 1 file</mat-error>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button type="button" [color]="'accent'" (click)="CancelHandler()">Cancel</button>
    <button mat-raised-button type="submit" [color]="'primary'" (click)="Upload()" [disabled]="file == null || multipleFiles">Upload</button>
</div>